module.exports = __webpack_public_path__ + "img/bottom-right-corner.1b369c45.svg";